export var SearchStatus;
(function (SearchStatus) {
    SearchStatus["Pending"] = "PENDING";
    SearchStatus["Done"] = "DONE";
})(SearchStatus || (SearchStatus = {}));
//# sourceMappingURL=search-status.type.js.map